import type { MessageRecordType } from "@/api/business/types/message"
import { MessageTypeConstants } from "@/api/business/types/message"
import { MessageType } from "@/types/messageType"

export const PACKAGE_COUNTDOWN_REMINDER_NOTIFICATION_DURATION_MS = 30 * 1000
export const RESERVATION_EXPIRED_NOTIFICATION_DURATION_MS = 30 * 1000

type RealtimeMessageType = typeof MessageType[keyof typeof MessageType]

export const getRealtimeNotificationDuration = (
  websocketMessageType: RealtimeMessageType,
  messageContent?: Pick<MessageRecordType, "messageType"> | null,
) => {
  const isPackageCountdownReminder = websocketMessageType === MessageType.PackageCountdownReminder
    || messageContent?.messageType === MessageTypeConstants.MESSAGE_TYPE_PACKAGE_COUNTDOWN_REMINDER

  if (isPackageCountdownReminder) {
    return PACKAGE_COUNTDOWN_REMINDER_NOTIFICATION_DURATION_MS
  }

  if (messageContent?.messageType === MessageTypeConstants.MESSAGE_TYPE_RESERVATION_EXPIRED) {
    return RESERVATION_EXPIRED_NOTIFICATION_DURATION_MS
  }

  return 0
}
